import React, { useRef } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import { startCase } from 'lodash';
import { useHandleModuleNavigation } from 'hooks';
import { ReportHeader } from 'modules/campaigns/components/ReportHeader/ReportHeader';
import CampaignReports from 'modules/campaigns/modules/campaigns-reports';
import * as reportConfigIndex from 'modules/campaigns/modules/campaigns-reports/config/reports/reportConfigIndex';
import useReportConfigMap from 'modules/campaigns/modules/campaigns-reports/config/reports/useReportConfigMap';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { StaticIndications } from '../../taboola-common-frontend-modules/Indications';
import { LandingPagesReportEmptyState } from '../components/ReportEmptyState/ReportEmptyState';
import { MODULE_NAME } from '../config';
import styles from './landingPagesReport.module.scss';

export const LandingPagesReport = () => {
    const location = useLocation();
    const history = useHistory();
    const containerRef = useRef();
    const { path } = useRouteMatch(null);
    const skipFetchReport = location?.state?.skipFetchReport;
    const handleNavigation = useHandleModuleNavigation({ history, path });
    const reportConfigMap = useReportConfigMap(reportConfigIndex);
    const buildReportNameForExport = selectedReport => ` - ${startCase(selectedReport)} Advertorials`;
    const { formatMessage } = useIntl();
    const title = formatMessage({
        id: 'landing.pages.report.header.updated',
        defaultMessage: 'Advertorials',
    });

    return (
        <div className={styles['container']}>
            <StaticIndications />
            <div className={styles['landing-pages-report-container']} ref={containerRef}>
                <CampaignReports
                    skipFetchReport={!!skipFetchReport}
                    parentContainerRef={containerRef}
                    module={MODULE_NAME}
                    header={<ReportHeader title={title} />}
                    rangePickerPresetConfigs={{}}
                    buildReportNameForExport={buildReportNameForExport}
                    reportConfigMap={reportConfigMap}
                    closeSideDrawer={handleNavigation}
                    EmptyStateComponent={LandingPagesReportEmptyState}
                    datePreset={null}
                />
            </div>
        </div>
    );
};
